function headerBarCarousel(){
    $('.header-bar__carousel').slick({
        "arrows": false,
        "infinite": true,
        "autoplay": true,
        "autoplaySpeed": 3000,
        "mobileFirst": true,
        "slidesToScroll": 1,
        "responsive": [
            {
                "breakpoint": 767,
                "settings": {"slidesToShow": 2}
            },
            {
                "breakpoint": 1199,
                "settings": {"slidesToShow": 3}
            }
        ]
    });
}


function mainBanner(){
    $('.main-banner__slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 4000,
        nextArrow: '<div class="companies__arrow-container"><div class="companies__arrow"></div></div>',
        prevArrow: '<div class="companies__arrow-container left"><div class="companies__arrow left"></div>',
    });
}

function companySlider(){
    $('.companies__slider').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: '<div class="companies__arrow">',
        prevArrow: '<div class="companies__arrow left">',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    arrows: false,
                }
            },
            {
                breakpoint: 996,
                settings: {
                    centerPadding: '15px',
                    slidesToShow: 4,
                    arrows: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '15px',
                    slidesToShow: 3,
                    arrows: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerPadding: '15px',
                    slidesToShow: 2,
                    arrows: false,
                    variableWidth: true,
                }
            }
        ]
    });
}

function productSliders(){
    $('.product__main-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.product__sub-slider',
    });

    $('.product__sub-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product__main-slider',
        dots: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
        ]
    });
}

function sectionProductsCarousel(){
    $('.section__products-carousel .products, .section__last-viewed .products').slick({
        slidesToShow: 4,
        slidesToScroll: 2,
        dots: true,
        arrows: true,
        nextArrow: '<div class="companies__arrow">',
        prevArrow: '<div class="companies__arrow left">',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                }
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                }
            },
        ]
    });
}

export default {
    headerBarCarousel,
    productSliders,
    companySlider,
    mainBanner,
    sectionProductsCarousel
};



// WEBPACK FOOTER //
// ./src/scripts/carousel.js